import { Component, inject } from '@angular/core';
import { AnalyticsService } from '../analytics.service';

@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrl: './page-footer.component.scss',
})
export class PageFooterComponent {
  readonly analytics = inject(AnalyticsService);
}
